export const ML_STALE_VARIATION_MAPPING_CODE = 'ML_STALE_VARIATION_MAPPING';

export function isStaleVariationMappingIssue(issue) {
  return (
    issue?.rawErrorCode === ML_STALE_VARIATION_MAPPING_CODE ||
    issue?.metadata?.resolutionBlockerCode === ML_STALE_VARIATION_MAPPING_CODE
  );
}

export function requiresManualVariationRemap(issue) {
  if (!isStaleVariationMappingIssue(issue)) return false;
  if (issue?.metadata?.staleVariationRecoveryMode === 'manual_remap_required') {
    return true;
  }
  return Array.isArray(issue?.metadata?.staleVariationMapping?.remoteVariationIds) &&
    issue.metadata.staleVariationMapping.remoteVariationIds.length > 0;
}

export function getStockResolutionErrorCode(error) {
  return String(error?.response?.data?.code || '').trim();
}

const stockSourceResolutionTypes = new Set([
  'stock_mismatch',
  'fanout_failed',
  'insufficient_stock',
]);

export function usesStockSourceResolutionFlow(issue) {
  return stockSourceResolutionTypes.has(issue?.type) && !isStaleVariationMappingIssue(issue);
}

export function hasLiveChannelStock(context) {
  const stock = Number(context?.channelStock);
  return (
    context?.channelStockSource === 'live' &&
    context?.channelStock !== null &&
    context?.channelStock !== undefined &&
    Number.isFinite(stock) &&
    stock >= 0
  );
}

export function summarizeBulkResolutionResponses(responses = []) {
  return responses.reduce(
    (summary, response) => {
      const result = response || {};
      summary.processed += 1;
      if (result.status === 'partial') summary.partial += 1;
      if (result.skippedRemoteMutation === true) {
        if (result.autoSuppressed === true) summary.autoSuppressed += 1;
        else summary.primarySkipped += 1;
      }
      summary.fanoutSkipped += Array.isArray(result.skippedFanoutTargets)
        ? result.skippedFanoutTargets.length
        : 0;
      if (
        result.status === 'resolved' &&
        (result.skippedRemoteMutation !== true || result.autoSuppressed === true)
      ) {
        summary.resolved += 1;
      }
      return summary;
    },
    {
      processed: 0,
      resolved: 0,
      partial: 0,
      primarySkipped: 0,
      autoSuppressed: 0,
      fanoutSkipped: 0,
    },
  );
}
